import { NavigationLinks } from '@/app/consts/navigationFooterLinks.ts';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const NavigationFooter = () => {
  const { t } = useTranslation();
  return (
    <div className=' bottom-0 shadow-xl w-full z-[9999]'>
      <footer className='text-center bg-[#EAF4F7] flex items-center justify-center'>
        <div className='w-[80%] py-1 flex items-center justify-center'>
          {NavigationLinks.map((item, index) => (
            <div
              className={`px-6 ${index !== 0 ? 'border-l border-l-[#DFE2E6]' : ''}`}
              key={`footer-nav-${index}`}
            >
              <Link className='text-350' to={item.path}>
                {t(item.label)}
              </Link>
            </div>
          ))}
        </div>
      </footer>
    </div>
  );
};
